import { global } from "../../constants";

export const data = {
  banner: {
    base: "Services",
    background: global.banner + "sts_services.webp",
    title: "STS Operations",
    crumb: "STS Operations",
  },
  icon: "fa-solid fa-exchange-alt",
  shortDescription:
    "Comprehensive services for Ship-to-Ship (STS) operations: planning, permits, technical supervision, and risk management for safe and compliant transfers.",
  title: "STS Operations",
  features: {
    title: "STS Operations",
    deliverables: "Deliverables",
    reqDocuments: "Required Documents",
    subtitle:
      "Planning, execution, and technical supervision of Ship-to-Ship operations (vessel-to-vessel transfer) in compliance with MARPOL, OCIMF/ISGOTT guidelines, and local regulations.",
    description: `We offer comprehensive STS services covering vessel pre-assessment, preparation and validation of the STS Plan, coordination of specialized teams (STS Master/Loading Master), verification of equipment and transfer systems, management of permits and communications with port and flag authorities, and support in claims and incident management. Our approach combines regulatory compliance, OCIMF/ISGOTT best practices, and compliance controls to mitigate operational, environmental, and legal risks.`,
    viewDetail: "View Details",
    feats: [
      {
        key: "plan_sts",
        title: "Preparation and Validation of the STS Operations Plan (MARPOL/OCIMF)",
        summary:
          "Drafting the STS Plan in accordance with MARPOL (Annex I) and OCIMF/ISGOTT guidelines, with approval and signatures required by the flag authority/client.",
        details:
          "We prepare the STS Plan including maneuver description, operational limits, certified equipment and hoses, arrival and departure procedures, responsibilities (Masters, Loading Master), communications, and mandatory pre-transfer checklist. We manage approval with the flag authority or competent entity when required.",
        deliverables: [
          "Complete STS Plan and signature version",
          "Pre-transfer and operational checklists",
          "Record of approvals and communications"
        ],
        requiredDocs: [
          "Previous STS Plan format or operator template",
          "Contact details of responsible parties and authorities",
          "Technical specifications of hoses and equipment"
        ],
        icon: "fa-solid fa-file-lines",
        image: global.services + "operations_sts/1.webp",
      },
      {
        key: "evaluacion_previa",
        title: "Pre-assessment and Operational Due Diligence",
        summary:
          "Technical and legal verification of vessels, crew, owners, and manifests before authorizing the STS operation.",
        details:
          "We perform KYC checks and technical due diligence: hull and tank compatibility, flag registration, safety certificates, incident history, sanction records, and insurer verification. This includes communication with consignees, shipowners, and STS equipment suppliers.",
        deliverables: [
          "Legal and technical due diligence report",
          "Compatibility list and detected risks",
          "Mitigation action recommendations"
        ],
        requiredDocs: [
          "Vessel classification and safety certificates",
          "Vessel registry and ownership documentation",
          "Claims/incidents history and insurance policies"
        ],
        icon: "fa-solid fa-search",
        image: global.services + "operations_sts/2.webp",
      },
      {
        key: "supervision_tecnica",
        title: "Technical Supervision and Specialized Personnel (STS Master / Loading Master)",
        summary:
          "Provision and coordination of STS supervisors (Masters/Loading Masters) and technicians to direct and oversee the operation.",
        details:
          "We provide or coordinate certified technicians and supervisors who direct the maneuver, control communications, verify connections, and authorize the start/stop of pumping. Roles and contact points (unified command) are established for the operation.",
        deliverables: [
          "Assignment of STS Master / Loading Master",
          "Roles and responsibilities sheet",
          "Post-transfer operational report"
        ],
        requiredDocs: [
          "CV and certifications of technical personnel",
          "Boarding authorizations and permits",
          "Operation schedule and time windows"
        ],
        icon: "fa-solid fa-user-astronaut",
        image: global.services + "operations_sts/3.webp",
      },
      {
        key: "equipamiento_y_mooring",
        title: "Equipment, Fenders, and Mooring Maneuver",
        summary:
          "Verification and provision of mooring systems, fenders, and approved safety equipment/hoses for the transfer.",
        details:
          "We validate fender specifications, mooring lengths, line forces, winch capacity, hull protection, and hose compatibility with the cargo. We coordinate fender suppliers and pumping systems with integrity tests before the maneuver.",
        deliverables: [
          "Equipment and fender checklist",
          "Hose and connection compatibility report",
          "Mooring plan with calculated forces"
        ],
        requiredDocs: [
          "Technical specifications of hoses and fenders",
          "Cargo data (density, temperature)",
          "Equipment maintenance records"
        ],
        icon: "fa-solid fa-anchor",
        image: global.services + "operations_sts/4.webp",
      },
      {
        key: "seguridad_medida_contaminacion",
        title: "HSE, Spill Response, and Environmental Contingencies",
        summary:
          "HSE planning, preventive measures, and coordination of the Contingency Plan for spills (OSCP) during the STS operation.",
        details:
          "We design specific HSE controls: atmosphere monitoring, ignition source control, emergency communication, space segregation plan, and coordination with OSCP/authorities in case of a spill. Includes availability of containment equipment and booms if applicable.",
        deliverables: [
          "Operation-specific HSE and contingency plan",
          "List of containment equipment and response contacts",
          "Post-operation report with safety observations"
        ],
        requiredDocs: [
          "Current contingency/OSCP plan",
          "Gas instrumentation and calibration certificates",
          "Vessel safety procedures"
        ],
        icon: "fa-solid fa-shield-halved",
        image: global.services + "operations_sts/5.webp",
      },
      {
        key: "compliance_y_permisos",
        title: "Permits, Notifications, and Local Compliance (including requirements in Venezuelan waters)",
        summary:
          "Management of port permits, notifications to competent authorities, and compliance with local requirements (e.g., INEA in Venezuela).",
        details:
          "We process authorizations with port and marine authorities, submit regulatory notifications (Aquatic Spaces Authority or similar), coordinate access routes and authorized zones, and verify insurance and bond requirements demanded by the local regulator.",
        deliverables: [
          "Processing and obtaining permits/notifications",
          "Record of communication with authorities",
          "List of fulfilled local requirements"
        ],
        requiredDocs: [
          "Operation request/plan sent to authority",
          "Vessel documentation and cargo manifest",
          "Required insurance policies and guarantees"
        ],
        icon: "fa-solid fa-landmark",
        image: global.services + "operations_sts/6.webp",
      },
      {
        key: "documentacion_entrega",
        title: "Documentation, Certifications, and Administrative Closure",
        summary:
          "Generation of transfer certificates, cargo delivery notes, and time/volume records for legal and commercial purposes.",
        details:
          "We issue transfer records (quantitative transfer statement), volume and temperature control, cargo receipt/delivery certificates, and accounting documentation for invoicing and claims. An operational dossier is maintained for subsequent audits.",
        deliverables: [
          "Transfer record and statement (QTY statement)",
          "Volume and transfer parameter report",
          "Operational dossier and signature record"
        ],
        requiredDocs: [
          "Manifests and Bill of Lading / cargo documentation",
          "Measurement records and laboratory certificates (if applicable)",
          "Authorized signatures from both parties"
        ],
        icon: "fa-solid fa-file-contract",
        image: global.services + "operations_sts/7.webp",
      },
      {
        key: "seguros_y_reclamaciones",
        title: "Insurance, Liability, and Claims Management",
        summary:
          "Advisory on placement of specific STS coverages and management of incidents/claims after a transfer.",
        details:
          "We review H&M, P&I, and cargo policies to identify coverage gaps during STS, advise on coverage extensions or temporary endorsements, and manage interaction with adjusters in case of losses, spills, or third-party damages.",
        deliverables: [
          "Coverage analysis and gap report",
          "Endorsement or temporary policy recommendations",
          "Assistance in claims management and coordination with insurers"
        ],
        requiredDocs: [
          "Current policies (H&M, P&I, Cargo)",
          "Incident and survey reports",
          "Official communication between parties"
        ],
        icon: "fa-solid fa-hand-holding-dollar",
        image: global.services + "operations_sts/8.webp",
      }
    ],
  },
  ctaText: "Request STS operation or quotation",
  ctaLink: "/contact?service=sts-operations",
};
